import type { DailyPlanData, DailyReportDetail, DailyReportsData, DailySource } from '@felix/ui';
import { api } from './api.js';

/**
 * Ofiste günlük iş planı ve raporlar (ADR 0051 §8–§9): salt okunur. Plan ve raporlar gemide yazılır;
 * ofis filonun gemilerini seçer ve görür. Yazma (`editor`) yok.
 */
export const officeDailySource: DailySource = {
  scope: 'web',
  plan: ({ vesselId, day }) => {
    const params = new URLSearchParams();
    if (vesselId) params.set('vesselId', vesselId);
    if (day) params.set('day', day);
    return api<DailyPlanData>(`/office/daily/plan?${params}`);
  },
  reports: ({ vesselId, from, to }) => {
    const params = new URLSearchParams();
    if (vesselId) params.set('vesselId', vesselId);
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    return api<DailyReportsData>(`/office/daily/reports?${params}`);
  },
  report: (id) => api<DailyReportDetail>(`/office/daily/reports/${encodeURIComponent(id)}`),
  fileUrl: (id) => `/api/office/attachments/${encodeURIComponent(id)}`,
};
